import { AfterViewInit, Component, Injector, OnInit } from '@angular/core';
import { UserGroupService } from 'tnx-admin-service/identityserver/usergroup/services';
import { ColumnSchemaBase, ComponentContextService, DataListBase, GridInfo, ModelSchema } from 'tnx-shared';
@Component({
    selector: 'usergroup',
    templateUrl: './usergroup.component.html',
    styleUrls: ['./usergroup.component.scss'],
    providers: [ComponentContextService],
})
export class UserGroupComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};
    constructor(
        protected _injector: Injector,
        protected _userGroupService: UserGroupService,
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.setting.popupSize.maximize = true;
        this.setting.baseService = this._userGroupService;
        this.setting.objectName = 'nhóm người dùng';
        this.setting.popupSize.height = 700;
        this.setting.popupSize.width = 1000;

        this.setting.modelSchemas = [
            new ModelSchema({ field: 'name', name: 'Tên', fullName: 'Tên', description: 'Tên' }),
            new ModelSchema({ field: 'description', name: 'Mô tả', fullName: 'Mô tả', description: 'Mô tả' }),
            new ModelSchema({ field: 'code', name: 'Mã', fullName: 'Mã', description: 'Mã' }),
        ];

        this.setting.cols = [
            new ColumnSchemaBase({ field: 'code' }),
            new ColumnSchemaBase({ field: 'name' }),
            new ColumnSchemaBase({ field: 'description' }),
        ];

        super.ngOnInit();
    }

    async modifyGridInfo(gridInfo: GridInfo) {
    }
}

